// external scripts
import $ from 'jquery';
import debug from 'bows';
import WdgSlideshow from './slideshow';
import WdgVerticalSlideshow from './vertical-slideshow';
import throttle from '../vendor/lodash-es/throttle';
import LayoutGallery from './layout-gallery';
import LayoutTabs from './layout-tabs';

// example of ES2015 modules loading & tree shaking
import { emptyLinks } from './links';

const $window   = $(window);
const $document = $(document);

class Site {
	constructor() {
		$document.ready(() => this.domReady());
		$window.on('load', () => this.windowLoad());
	}

	domReady() {
		const log = debug('site:domReady');
		log('dom.ready');
		this.headerSearch();
		this.facetSearch();
		this.offsetImage();
		this.layouts();
		this.mobile();
		this.filterBar();
		this.gsipToolkit();
		this.inThisSection();
	}

	windowLoad() {
		const log = debug('site:windowLoad');
		log('window.onload');

		// example of ES2015 modules loading & tree shaking
		emptyLinks();

		this.homeHero();
		this.featuredEvents();
		this.relatedResources();
	}

	headerSearch() {
		const log = debug('site:header');
		const $header = $('.header');

		if (!$header.length) {
			return;
		}

		let active = $header.hasClass('header--search-enabled');
		const toggle = () => {
			$header.toggleClass('header--search-enabled', active);

			if (active) {
				$header.find('input.search-field').trigger('focus');
			}

			log('toggle search', active);
		}

		$header.on('click', '.js-search-toggle', (e) => {
			e.preventDefault();

			active = !active;
			toggle();
		});

		$header.on('click', '.js-search-submit', (e) => {
			e.preventDefault();

			$header.find('form.search-form')[0].submit();
		});

		$(document).on('keyup', (e) => {
			if (active && e.keyCode === 27) {
				active = false;
				toggle();
				log('toggled search from `esc` key');
			}
		});

		let swiftypeMeta = $('meta[name="swiftype-engine-key"]');
		let swiftypeEngineKey = (swiftypeMeta.length === 1 && swiftypeMeta.attr('content')) ? swiftypeMeta.attr('content') : '-FFATyXRyizkhUraVgEG';

		$header.find('input.search-field').swiftype({
			engineKey: swiftypeEngineKey
		});
	}

	facetSearch(){
		const $form = $('.header__search .search-form');
		const $facet_list = $('.srch--facets');
		// const $result_container = $('.main-container .content-sidebar__content .entries');

		let matches = null;
		const pl     = /\+/g;  // Regex for replacing addition symbol with a space
		const search = /([^&=]+)=?([^&]*)/g;
		const decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); };
		const query  = window.location.search.substring(1);

		let urlParams = {};

		matches = search.exec(query);
		while (matches) {
			urlParams[decode(matches[1])] = decode(matches[2]);
			matches = search.exec(query);
		}

		jQuery.each(urlParams, function(idx, itm){
			var found = $('.srch--facets .fct_grp_src .fct_v input[type="checkbox"][name="'+ idx +'"][value="'+ itm.replace(/"/g, '\\\"') +'"]').attr('checked', 'checked');
			found.attr('checked', 'checked');
		});


		$facet_list.on('change', '.fct_grp_src .fct_v input', () => {
			let all_facets = $facet_list.find('.fct_v input[type="checkbox"]:checked');

			$form.find('input[type="checkbox"]').remove();
			$form.append(all_facets.clone());

			$facet_list.find('.fct_grp_src .fct_v input').attr('disabled', 'disabled');

			$form.submit();
		}).on('click', '.modifier', function() {
			$(this).parent('.fct_grp').toggleClass('show_more');
		});

		$facet_list.on('click', '.fct_grp_src h2', (e) => {
			e.stopImmediatePropagation();

			if( $(e.target).is('input') ){
				return true;
			}

			let _this = $(e.target);

			_this.closest('.fct_grp_src').toggleClass('off');

			_this.closest('.fct_grp_src').siblings('.fct_grp_src').addClass('off');

			return false;
		});

		$facet_list.on('click', '.fct_grp_src .fct_grp h3', function(){
			$(this).parent('.fct_grp').find('.modifier').click();
		});

		$facet_list.find('.fct_grp_src .fct_v input').removeAttr('disabled');
	}

	homeHero() {
		const $containers = $('.home-hero__content.slideshow');

		if (!$containers.length) {
			return;
		}

		$containers.each((i, container) => new WdgVerticalSlideshow({ container }));
	}

	featuredEvents() {
		const $containers = $('.featured-events.slideshow');

		if (!$containers.length) {
			return;
		}

		const flickityOptions = { pageDots: false };
		$containers.each((i, container) => new WdgSlideshow({ container, flickityOptions }));
	}

	relatedResources() {
		const flickityOptions = { pageDots: false, wrapAround: true };
		$('.related-resources.slideshow').each((i, container) => new WdgSlideshow({ container, flickityOptions }));
	}

	offsetImage() {
		const log = debug('site:offsetImage');
		const $containers = $('.offset-image');

		if (!$containers.length) {
			return;
		}

		const resize = (container) => {
			log('resize', container);
			const $container = $(container);
			const width  = $container.width() + $container.offset().left;
			$container.find('img').css({ width });
		};

		$containers.each((i, container) => {
			resize(container)
			$window.on('resize', throttle(() => resize(container), 16.666));
		});
	}

	layouts() {
		if ($('.layout-slider').length) {
			const flickityOptions = { pageDots: false };
			$('.layout-slider.slideshow').toArray().forEach((container) => new WdgSlideshow({ container, flickityOptions }));
		}

		if ($('.layout-gallery').length) {
			$('.layout-gallery').toArray().forEach((container) => {
				const imagesContainer = $(container).find('.layout-gallery__images')[0];
				new LayoutGallery({
					viewportWidth: 801,
					container: imagesContainer
				});
			});
		}

		if ($('.layout-tabs').length) {
			$('.layout-tabs').toArray().forEach((container) => {
				new LayoutTabs({ container });
			});
		}
	}

	mobile() {
		$('.header .header__mobile-icon').on('click', (e) => {
			e.preventDefault();
			$('body').toggleClass('mobile-menu-active');
		});
	}

	filterBar() {
		const $container = $('.filter-bar');
		if (!$container.length) {
			return;
		}

		const $select = $('.filter-bar__dropdown select');
		$select.on('change', (e) => {
			const value = $(e.target).val();
			document.location.href = value;
		});
		$select.select2();
	}

	gsipToolkit() {
		const $button = $('.gsip-toolkit__share-button');
		$button.each((i, button) => {
			const $button = $(button);
			$button.on('click', () => {
				$button.hide();
				$button.next().addClass('gsip-toolkit__share-icons--active');
			});
		});

		const $select = $('.gsip-toolkit__nav select');
		$select.on('change', (e) => {
			const value = $(e.target).val();
			if (value) {
				document.location.href = value;
			}
		});
		$select.select2({
			allowClear: true,
			minimumResultsForSearch: Infinity,
			placeholder: 'Select an option',
		});

		$('.nav__menu-item--has-submenu > .nav__menu-item-trigger').on('click', (e) => {
			$(e.target).closest('.nav__menu-item').toggleClass('nav__menu-item--opened');
		});

		$('.nav__menu-item--has-submenu').each((i, li) => {
			const $li = $(li);
			if ($li.hasClass('nav__menu-item--active-ancestor') || $li.hasClass('nav__menu-item--active')) {
				$li.addClass('nav__menu-item--opened');
			}
		});
	}

	inThisSection() {
		const log = debug('site:inThisSection');

		if (!$('.in-this-section').length) {
			log('skipped');
			return;
		}

		let animating = false;
		const viewportOffset = parseInt($('html').css('margin-top'), 10);

		const section = $('.in-this-section');
		const $content = $($(section).data('content'));
		const $headings = $content.find('h1, h2, h3, h4, h5, h6');
		let html = '';
		let optionsHtml = '';
		log({ section, $headings });

		$headings.each((i, heading) => {
			const $heading = $(heading);
			let id = $heading.attr('id');
			if (!id) {
				id = `${i}`;
				$heading.attr('id', id);
			}
			const depth = heading.nodeName[1];
			const text = $heading.text();
			html += `<li class="in-this-section__item in-this-section__item--depth${depth}"><a href="#${id}">${text}</a></li>`;
			optionsHtml += `<option value="#${id}">${text}</option>`;
		});

		$('.in-this-section__items', section).append(html);

		const $select = $('.in-this-section-bar select').append(optionsHtml);
		$select.on('change', (e) => {
			const value = $(e.target).val();
			if (value) {
				animating = true;
				// animate scrolling
				const scrollTop = $(value).offset().top - (25 + viewportOffset);
				$('html, body').stop().animate({ scrollTop }, 1000, () => {
					animating = false;
				});
			}
		});
		$select.select2({
			minimumResultsForSearch: Infinity,
		});

		$document.on('click', '.in-this-section__item a', (e) => {
			e.preventDefault();
			animating = true;

			// get link's scroll top
			const id = $(e.target).attr('href');
			const scrollTop = $(id).offset().top - (25 + viewportOffset);

			// animate scrolling
			$('html, body').stop().animate({ scrollTop }, 1000, () => {
				animating = false;
			});
		});

		// get the footer offset after the links have been added
		let headingOffsets;
		let footerOffset;

		$window.on('resize', throttle(() => {
			headingOffsets = [];
			$headings.each((i, heading) => {
				headingOffsets.push({
					index: i,
					offset: $(heading).offset().top - (25 + viewportOffset),
					text: $(heading).text()
				});
			});
			footerOffset = $('.footer').offset().top;
		}, 16.666));
		$window.trigger('resize');

		$window.on('scroll', throttle(() => {
			const { scrollY } = window;
			$select.select2('close');

			if (scrollY < headingOffsets[0].offset || scrollY >= footerOffset) {
				$('.in-this-section-bar').removeClass('in-this-section-bar--active');
				return;
			}

			let activeOffset = null;
			headingOffsets.forEach((offset) => {
				if (scrollY >= offset.offset) {
					activeOffset = offset.index;
				}
			});

			if (!animating && activeOffset !== null) {
				const value = $select.find('option').eq(activeOffset).val();
				$select.val(value);
				$select.trigger('change.select2');
				$('.in-this-section-bar').addClass('in-this-section-bar--active');
			}
		}, 16.666));
	}
}

export default Site;
